export default __webpack_public_path__ + "static/media/cross.1a47d3f7.svg";